import Model, { attr } from '@ember-data/model';

export default class SerpResultAiOverview extends Model {
  @attr('string') url;
  @attr('string') title;
}
